import { __extends } from 'tslib';
import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { t } from '../../localization.js';
import styles from './Dialog.module.scss.js';

var DEFAULT_ROOT_ID = 'modal-root';
var dialogFadeLeaveTimeout = 300;
var overlayFadeEnterTimeout = 300;
var overlayFadeLeaveTimeout = 300;
var playButtonSound = web2clientSounds.playButtonSound, playCloseDialogSound = web2clientSounds.playCloseDialogSound, playOpenDialogSound = web2clientSounds.playOpenDialogSound;
var overlayKey = 'overlay-fade';
var overlayName = 'overlay-fade';
var dialogKey = 'dialog-fade';
var dialogName = 'dialog-fade';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEscape = function (e) {
            if (e.keyCode === 27 && _this.props.isVisible) {
                e.preventDefault();
                if (_this.props.size !== 'introduction') {
                    playCloseDialogSound();
                    _this.props.hideDialog();
                }
            }
        };
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.onEscape, true);
    };
    Dialog.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.isVisible !== this.props.isVisible) {
            nextProps.isVisible ? playOpenDialogSound() : playCloseDialogSound();
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.onEscape, true);
    };
    Dialog.prototype.render = function () {
        var _this = this;
        if (!window)
            return null;
        var id = this.props.rootId ? this.props.rootId : DEFAULT_ROOT_ID;
        var modalRoot = window.document.getElementById(id);
        var overlay = null;
        var dialog = null;
        if (this.props.isVisible) {
            var classNameDialog = classNames(styles.dialog, styles["dialog__" + this.props.size]);
            var dialogContent = this.props.content ? this.props.content : null;
            var showCloseButton = !this.props.isOverlay && this.props.size !== 'introduction';
            var close_1 = showCloseButton ? (React.createElement("div", { key: "close", className: styles.close, onClick: function (e) {
                    e.preventDefault();
                    playButtonSound();
                    _this.props.hideDialog();
                } }, t('Закрыть'))) : null;
            overlay = (React.createElement("div", { key: "overlay", className: styles.overlay, style: { background: this.props.overlayBackground || '' } }));
            dialog = (React.createElement("div", { key: "dialog", className: styles.dialogWrapper },
                React.createElement("div", { className: classNameDialog },
                    close_1,
                    dialogContent)));
        }
        if (modalRoot) {
            return ReactDOM.createPortal(React.createElement("div", { className: this.props.className || '' },
                React.createElement(ReactCSSTransitionGroup, { key: overlayKey, transitionName: overlayName, transitionEnterTimeout: overlayFadeEnterTimeout, transitionLeaveTimeout: overlayFadeLeaveTimeout }, overlay),
                React.createElement(ReactCSSTransitionGroup, { key: dialogKey, transitionName: dialogName, transitionEnter: false, transitionLeaveTimeout: dialogFadeLeaveTimeout }, dialog)), modalRoot);
        }
        else {
            return null;
        }
    };
    return Dialog;
}(React.PureComponent));

export { Dialog as default };
//# sourceMappingURL=Dialog.js.map
